import Feedback from './feedback';

export default Feedback;
